import { useState, useEffect } from "react";

function RedesignedHero({ onPlayWithEIE, isPlayDisabled = false }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const slides = [
        { 
            label: "The Importance of Emotions", 
            tag: "Two Twins one content, endless emotions",
            image: "/assets/img/EIE-2Twins.jpeg",
            mobilePosition: "70% top"
        },
        { 
            label: "Engagement", 
            tag: "AlphaHub EIE for Engagement",
            image: "/assets/img/EIE-Engagement.jpeg",
            mobilePosition: "center top"
        },
        { 
            label: "VR & AR", 
            tag: "AlphaHub EIE VR Experiences",
            image: "/assets/img/EIE-VR-AR.png",
            mobilePosition: "center top"
        },
        { 
            label: "Healthcare", 
            tag: "AlphaHub EIE Healthcare Solutions",
            image: "/assets/img/EIE-Healthcare.png",
            mobilePosition: "center top"
        },
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 7000);
        return () => clearInterval(timer);
    }, [slides.length]);

    const openCogi = () => {
        if (window.Cogi && window.Cogi.instance && window.Cogi.instance.show) {
            window.Cogi.instance.open();
        }
    };

    const isMobile = window.innerWidth <= 768;

    return (
        <section className="cinematic-hero">
            {/* Aurora Effect */}
            <div className="aurora-layer"></div>
            <div className="aurora-layer-2"></div>
            
            {/* Cyber particles effect */}
            <div className="cyber-particles"></div>
            
            {/* Carousel Background */}
            <div className="hero-carousel">
                {slides.map((slide, i) => (
                    <div 
                        key={i} 
                        className={`hero-slide ${i === currentSlide ? 'active' : ''}`}
                        style={{ 
                            backgroundImage: `url(${slide.image})`,
                            ...(isMobile && { backgroundPosition: slide.mobilePosition })
                        }}
                    >
                        <div className="hero-slide-overlay"></div>
                    </div>
                ))}
            </div>
            
            {/* Carousel Indicators */}
            <div className="carousel-indicators">
                {slides.map((slide, i) => (
                    <button
                        key={i}
                        className={`carousel-dot ${i === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(i)}
                        aria-label={slide.label}
                    >
                        <span className="carousel-dot-label">{slide.tag}</span>
                    </button>
                ))}
            </div>
            
            <div className="cinematic-hero-container">
                <div className="cinematic-hero-content">
                    <p className="cinematic-badge">PATENT PENDING · FASHION · MEDIA · EDUCATION · HEALTHCARE</p>
                    <h1 className="cinematic-hero-title">
                       Transform Every Interaction with<br />
                        <span className="cinematic-hero-accent">Emotional Intelligence</span>
                    </h1>
                    <p className="cinematic-hero-description">
                        <span className="hero-line">90% of human decisions at the moment of intent are driven by emotion, not logic.</span>
                        <span className="hero-line">This universal truth makes EIE applicable to every industry involving human interaction — from Healthcare and Insurance to Media, Training, VR, and Marketing.</span>
                        <span className="hero-line">One engine, infinite applications. <span className="hero-handle-emotions">Endless emotions.</span></span>
                    </p>
                    <div className="cinematic-hero-ctas">
                        <button
                            className="cinematic-cta-primary"
                            disabled={isPlayDisabled}
                            aria-disabled={isPlayDisabled}
                            onClick={() => {
                                if (isPlayDisabled) return;
                                if (typeof onPlayWithEIE === 'function') {
                                    onPlayWithEIE();
                                    return;
                                }
                                document.getElementById('eie-demo')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }}
                            style={isPlayDisabled ? { opacity: 0.55, cursor: 'not-allowed', filter: 'saturate(0.75)' } : undefined}
                            title={isPlayDisabled ? 'EIE experience is already running' : undefined}
                        >
                            {isPlayDisabled ? 'EIE Running' : 'Play With EIE'}
                        </button>
                        <button className="cinematic-cta-secondary" onClick={openCogi}>Talk to Cogi</button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default RedesignedHero;
